import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SuperAdminUnitsPageLayout from '../../../layout/SuperAdminUnitsPageLayout';
import { getInstitution } from '../../../api/admin/institutions';
import EditorsList from '../../../components/EditorsList';
const EditorsPerInstitutionPage = () => {
    const { id } = useParams();
    const [institutionName, setInstitutionName] = useState('');
    const getInstitutionName = async () => {
        const institution = await getInstitution(id);
        setInstitutionName(institution.institution.name);
    };
    useEffect(() => {
        if (id) {
            getInstitutionName();
        }
    }, [id]);
    return (_jsx(SuperAdminUnitsPageLayout, { title: institutionName, unit: 'editor', institutionId: id, children: _jsx(EditorsList, { role: 'super_admin' }) }));
};
export default EditorsPerInstitutionPage;
